import { AlertBanner, Button, ErrorState, Loading } from '@idu-nightlife/ui-kit';
import { Container, Stack } from '@mui/material';
import { StandardPageLayout } from '../../../shared/components/standard-page-layout/standard-page-layout';
import { AccountSecurityDialogs } from './account-security-dialogs';
import {
  MethodsSection,
  RememberedDevicesSection,
  TwoStepStateSection,
} from './account-security-sections';
import type { AccountSecurityViewProps } from './account-security.types';

const AccountSecurityContent = (props: AccountSecurityViewProps) => {
  const { load, busy, onRetryLoad } = props;

  if (load.state === 'loading') return <Loading />;
  if (load.state === 'error') {
    return (
      <Stack sx={{ gap: 1, alignItems: 'center' }}>
        <ErrorState message="Your sign-in settings couldn't be loaded." />
        <Button variant="secondary" onClick={onRetryLoad}>
          Try Again
        </Button>
      </Stack>
    );
  }

  return (
    <Stack sx={{ gap: 3 }}>
      <TwoStepStateSection {...props} status={load.status} busy={busy} />
      <MethodsSection {...props} status={load.status} busy={busy} />
      <RememberedDevicesSection {...props} busy={busy} />
    </Stack>
  );
};

export const AccountSecurityView = (props: AccountSecurityViewProps) => (
  <Container maxWidth="md" sx={{ py: 3 }}>
    <StandardPageLayout title="Account Security">
      <Stack sx={{ gap: 1 }}>
        {props.error && <AlertBanner severity="error">{props.error.message}</AlertBanner>}
        <AccountSecurityContent {...props} />
      </Stack>
      <AccountSecurityDialogs {...props} />
    </StandardPageLayout>
  </Container>
);
